import React from 'react';
import Reveal, { RevealChild, STAGGER } from '../../../components/motion/Reveal';
import { WORKFLOW_CHAPTERS } from '../data';
import SectionMasthead from './SectionMasthead';
import ChapterVisual from './ChapterVisual';
import styles from '../Home.module.css';

/* ─── Workflow: stacked ledger (mobile, reduced motion) ───
   Each chapter is marked by its phase + scene (never a numeral — the
   only numbered spine on the page is the section mastheads). Lists key
   on the unique `scene`, since two chapters share the "During" phase. */
const WorkflowStacked: React.FC = () => (
  <section
    id="workflow"
    className={styles.workflowSection}
    aria-labelledby="workflow-title"
  >
    <SectionMasthead
      index="02"
      label="The workflow"
      titleId="workflow-title"
      title={
        <>
          From first enquiry
          <br />
          to final gallery.
        </>
      }
    />

    <ul className={styles.chapterList}>
      {WORKFLOW_CHAPTERS.map((chapter) => (
        <li key={chapter.scene} className={styles.chapterRow}>
          <Reveal staggerInterval={STAGGER.normal} className={styles.chapterInner}>
            <RevealChild as="span" className={styles.chapterPhase}>
              {chapter.phase}
              <span aria-hidden="true"> · </span>
              <span className={styles.chapterScene}>{chapter.scene}</span>
            </RevealChild>
            <div>
              <RevealChild as="h3" className={styles.chapterTitle}>
                {chapter.title}
              </RevealChild>
              <RevealChild as="p" className={styles.chapterBody}>
                {chapter.body}
              </RevealChild>
              <RevealChild as="ul" className={styles.chapterLedger}>
                {chapter.details.map((detail) => (
                  <li key={detail} className={styles.chapterLedgerRow}>
                    {detail}
                  </li>
                ))}
              </RevealChild>
            </div>
          </Reveal>
          <div className={styles.chapterVisualInline}>
            <figure className={styles.captionedFigure}>
              <ChapterVisual chapter={chapter} />
              <figcaption className={styles.frameCaption}>
                {chapter.frame}
              </figcaption>
            </figure>
          </div>
        </li>
      ))}
    </ul>
  </section>
);

export default WorkflowStacked;
